module.exports = __webpack_public_path__ + "static/media/CDs.8918ed5e.jpg";